<ngx-loading-bar [includeSpinner]="false" color="#6439ff"></ngx-loading-bar>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#ffffff" type="ball-clip-rotate" [fullScreen]="true">
  <p style="color: white">Cargando...</p>
</ngx-spinner>
<router-outlet></router-outlet>
